import React from 'react';
import i18next from 'i18next';

import type { DetailsPageProps, ViewPageProps } from 'app/main/components/page-layouts';
import type { AppRouteGroup } from 'app/store/components/NavigationUtils';
import { lazyRetry } from 'app/main/components';

import MarketingActionsListItem from './MarketingActionsListItem';
import MarketingActionsDetails from './details/MarketingActionsDetails';
import MarketingActionsDetailsRightSidebar from './details/MarketingActionsDetailsRightSidebar';

import buttons from './MarketingActionsButtons';
import events from './MarketingActionsEvents';

import en from './i18n/en';
import it from './i18n/it';

const ViewPage = lazyRetry<ViewPageProps>(() => import('app/main/components/page-layouts/view/ViewPage'));
const DetailsPage = lazyRetry<DetailsPageProps>(() => import('app/main/components/page-layouts/details/DetailsPage'));

i18next.addResourceBundle('en', 'core', en);
i18next.addResourceBundle('it', 'core', it);

const routes: AppRouteGroup = {
	settings: {},
	auth: ({ isModuleDisabled }) => isModuleDisabled('marketingactions'),
	routes: [
		{
			path: 'marketingactions/add/:tabId?',
			auth: ({ authorizer }) => authorizer.can('create', 'marketingactions'),
			element: (
				<DetailsPage
					key="marketingactions/add"
					module="marketingactions"
					tabs={MarketingActionsDetails}
					buttons={buttons.details}
					events={events}
					isAdd
				/>
			)
		},
		{
			path: 'marketingactions/details/:id/:tabId?',
			auth: ({ authorizer }) => authorizer.can('view', 'marketingactions'),
			element: (
				<DetailsPage
					key="marketingactions/details"
					module="marketingactions"
					tabs={MarketingActionsDetails}
					buttons={buttons.details}
					events={events}
					getRightSidebarSections={MarketingActionsDetailsRightSidebar}
				/>
			)
		},
		{
			path: 'marketingactions/:tabId?',
			auth: ({ authorizer }) => authorizer.can('view', 'marketingactions'),
			element: (
				<ViewPage
					key="marketingactions/view"
					module="marketingactions"
					content={{ type: 'list', itemLayout: MarketingActionsListItem, id: 'marketingActionsView' }}
					buttons={buttons.view}
				/>
			)
		}
	]
};

export default routes;
